define('app/views/vendor_rating_landing_page_view',['app/setup',
  'app/collections/vendor_rate_collection'], function(takhfifan) {
  takhfifan.VendorRatingLandingPageView = Backbone.View.extend({
    events: {
      'click .vr-rating .rate': 'rating',
      'click .tabs-content a': 'selectOptions',
      'click .footer-buttons a.submit': 'submitRate'
    },

    initialize: function() {
      this.negativeOptions = [];
      this.positiveOptions = [];
      this.couponHash = $(this.$el).data('coupon-hash');
      this.rateValue = "";
      this.currentStep = 1;
      this.collection = new takhfifan.VendorRateCollection;
      this.ratingValue = $(this.$el).data('rating-value');
      $(this.$el).attr('disabled', false);
      if(this.ratingValue && this.rateValue !== null){
        this.ratingProgress();
        $(".rating-box.step_3").css('display','block');
        $('.vr-rating').addClass('rating-passed rating-finished');
        $('.arrow').css('display','none');
        $('.step-'+this.ratingValue).addClass('selected');
        this.setFeelingStatus(this.ratingValue);
        $('.tkh-review-step-one').addClass('passed');
      }
      else {
        var marginTop;
        $(".rating-box.step_2").css('display', 'block');
        if($(window).width() < 769)
        {
          marginTop = $('.header-background.hide-on-desktop').innerHeight() - ( $('.emoji-star').height() / 2 );
        } else {
          marginTop = $('.header-background.hide-on-mobile').innerHeight() - ( $('.emoji-star').height() / 2 );
        }
        $('.emoji-star').css({"margin-top": marginTop, position: 'static'});
      }
    },

    rating: function(e){
      var _this=this;
      if ($('.vr-rating').hasClass('rating-finished')){
        return
      }
      $('.vr-rating .rate').removeClass("selected").removeClass("passed");
      $(e.currentTarget).addClass("selected");
      $('.vr-rating .arrow').css('display', 'none');
      var val = $(e.currentTarget).attr("class").match(/\d+/g)[0];
      $($("#stepTwoRateStars").children()[val -1]).addClass("selected");
      $('.vr-rating').addClass('rating-passed');
      this.setFeelingStatus(val);
      this.rateValue = val;
      if(this.currentStep === 1){
        this.currentStep = 2;
        setTimeout(function () {
          _this.ratingProgress();
        }, 1000);
      }
    },

    ratingProgress: function(){
      var marginTop;
      $('.tkh-review-step-one').addClass('passed').find("p").andSelf().filter("p:first").first().css("display", "none");
      $('.tkh-review-step-one .review-wrapper').addClass("visible");
      if($(window).width() < 769)
      {
        marginTop = ($('.header-background.hide-on-desktop').innerHeight() / 2) - ( $('.emoji-star').height()) -20;
      }
      else{
        marginTop = ($('.header-background.hide-on-mobile').innerHeight() / 2) - ( $('.emoji-star').height()/2 );
      }
      $('.emoji-star').css({"margin-top": marginTop, position: 'static'});
    },

    selectOptions: function(e){
      var type = $(e.currentTarget).data('type'),
          id = $(e.currentTarget).data('id');

      if(type === 'negative'){
        var isContainNegative = _.contains(this.negativeOptions, id);
        if(!isContainNegative){
          this.negativeOptions.push(id);
        }else{
          this.negativeOptions = _.filter(this.negativeOptions, function(r){ return r !== id; });
        }
      }else if(type === 'positive'){
        var isContainPositive = _.contains(this.positiveOptions, id);
        if(!isContainPositive){
          this.positiveOptions.push(id);
        }
        else{
          this.positiveOptions = _.filter(this.positiveOptions, function(r){ return r !== id; });
        }
      }

      $(e.currentTarget).toggleClass("selected");
    },

    setFeelingStatus: function (val) {
      var allPrevElements = $('.vr-rating .rate.selected').prevAll();
      $(allPrevElements).addClass("passed");

      var message = "";

      switch (parseInt(val)) {
        case 1:
          message = "راضی نبودم";
          break;
        case 2:
          message = "نظرم رو جلب نکرد";
          break;
        case 3:
          message = "بد نبود";
          break;
        case 4:
          message = "راضی بودم";
          break;
        case 5:
          message = "بی نظیر بود";
          break;
        default:
          break;
      }

      $('.message').text(message);

      var _src = $('.emoji-star').data('path');

      $('.emoji-star').removeClass('flip');
      setTimeout(function(){
        $('.emoji-star').addClass('flip');
        setTimeout(function () {
          $('.emoji-star').attr('src', _src + '/star-' + val + ".svg");
        }, 200);
      }, 50);
    },

    submitRate: function (e) {
      this.$el.attr('disabled', true);
      var _this = this;

      this.collection.rate({
        dataType: 'json',
        data: {
          form_key: takhfifan.formKey,
          c: _this.couponHash,
          rate: _this.rateValue,
          positive_questions: _this.positiveOptions.toString(),
          negative_questions: _this.negativeOptions.toString(),
          message: $('#vendorRatingMessage').val()
        },
        success: function (collection) {
          $('.vr-rating').addClass('rating-finished');
          setTimeout(function () {
            _this.$el.attr('disabled', false);
              $('.rating-box.step_3').show();
              $('.rating-box.step_2').hide();
          }, 500);
        },
        error: function () {
          $('.error').show();
        },
        complete: function () {}
      })
    }

  });

});





